import { setRangeMin } from './helpers';

export const setKitchenAreaMin = setRangeMin('kitchen');
